import { AuthErrorCode, AuthErrorMetadata } from '@worknet/models';

export function getUserFriendlyErrorMessage(
  code?: AuthErrorCode,
  metadata?: AuthErrorMetadata,
  fallbackMessage?: string
): string {
  if (!code) {
    return fallbackMessage || 'An error occurred. Please try again.';
  }

  switch (code) {
    case AuthErrorCode.APP_DOMAIN_NOT_FOUND: {
      const integration = metadata?.integrationType || 'integration';
      const domain = metadata?.domain || 'specified domain';
      return `The ${integration} domain "${domain}" is not configured in your organization. Please contact your administrator.`;
    }

    case AuthErrorCode.APP_NOT_CONFIGURED: {
      const integration = metadata?.integrationType || 'app';
      if (integration === 'slack') {
        return 'Slack app is not configured for this workspace or channel. Please contact your administrator.';
      }
      return `The ${integration} app is not configured. Please contact your administrator.`;
    }

    case AuthErrorCode.ENTITY_NOT_FOUND: {
      const integration = metadata?.integrationType || 'integration';
      const entityType = metadata?.entityType || 'resource';
      const entityId = metadata?.entityId || 'unknown';
      return `${capitalize(integration)} ${entityType} "${entityId}" was not found. It may have been deleted or you don't have access to it.`;
    }

    case AuthErrorCode.UNAUTHORIZED:
    default:
      return fallbackMessage || 'Unauthorized. Please check your credentials and try again.';
  }
}

export function getErrorTitle(code?: AuthErrorCode): string {
  switch (code) {
    case AuthErrorCode.APP_DOMAIN_NOT_FOUND:
    case AuthErrorCode.APP_NOT_CONFIGURED:
      return 'Configuration Error';
    case AuthErrorCode.ENTITY_NOT_FOUND:
      return 'Not Found';
    case AuthErrorCode.UNAUTHORIZED:
    default:
      return 'Error';
  }
}

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
